This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    class="draggable drag-4"
    :class="checker ? 'selected' : ''"
    @click="clicked"
  >
    <div class="inop">
      <!-- Block as shown in the instructions container -->
      <div class="preview">&infin;</div>

      <!-- Block as shown in the PSD/IDE -->
      <div class="hidden codeBlock parent">
        <p>&infin;</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { addExtra, checkUsedBlock } from "@/utils/Functions";

@Options({
  name: "in-op-block",
  props: {},
  methods: {
    getTranslation(s: string) {
      return this.json[this.lang][s];
    },
    clicked() {
      addExtra("infinite");
    },
  },
  computed: {
    checker() {
      return checkUsedBlock("bool");
    },
  },
})
export default class InfinOp extends Vue {}
</script>
